import { createMuiTheme, Theme } from "@material-ui/core/styles";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";

const white = "#F9F9F9";
const black = "#000";
export const featureTileYellow = "#F9C71A";
export const zigzagBackgroundBlack = "#1a1b1f";

export const footerItemHoverOpacity = 0.8;
export const newsItemHoverOpacity = 0.8;
export const mediaItemHoverOpacity = 0.8;
export const buttonHoverOpacity = 0.8;

export const darkTextBoxBackgroundColour = "#1C1C1C";

export const socialMediaColours = {
    twitter: "#1da1f2",
    facebook: "#3d5a99",
    youtube: "#f00",
    instagram: "#ea0d78",
    discord: "#7289DA",
};

// TODO: look at transitions
export const transition = {
    delay: "0s",
    duration: "0.15s",
    property: "all",
    timingFunction: "ease-in-out",
};

export const tileHoverEffect = {
    duration: 300,
};

export const cssImportant = " !important";
export const transparentColour = "transparent";

export const skeletonAnimation = "wave";

export const fonts = {
    primary: "permanent-marker, sans-serif",
    secondary: "montserrat, sans-serif",
};

const theme: Theme = createMuiTheme({
    palette: {
        primary: {
            main: "#FF1CD7",
        },
        secondary: {
            main: "#F9C71A",
        },
        background: {
            default: "#202020",
            paper: "#E0E0E0",
        },
        common: {
            white: white,
            black: black,
        },
    },
    typography: {
        fontFamily: fonts.primary,
        body1: {
            fontFamily: fonts.secondary,
            fontWeight: 700,
            fontSize: "0.875rem",
        },
        body2: {
            fontFamily: fonts.primary,
        },
        button: {
            fontFamily: fonts.secondary,
            fontWeight: 900,
        },
    },
});

export const navBarColour = theme.palette.common.black;

export const layoutConsts = {
    siteContentMaxWidth: 1200,
    defaultSkewDegrees: -0.5,
    defaultTiltDegrees: -1,
};

export const skeletonColour = theme.palette.grey[200];

type BreakpointPadding = {
    [key in Breakpoint]: number;
};

export const gutterPadding: BreakpointPadding = {
    xl: theme.spacing(6),
    lg: theme.spacing(6),
    md: theme.spacing(6),
    sm: theme.spacing(4),
    xs: theme.spacing(1),
};

export const horizontalPadding: BreakpointPadding = {
    xl: theme.spacing(4),
    lg: theme.spacing(4),
    md: theme.spacing(4),
    sm: theme.spacing(3),
    xs: theme.spacing(2),
};

export const articleContentLayout = {
    maxWidth: 1000,
    gutterPadding: theme.spacing(10),
    topBottomPadding: theme.spacing(6),
};

export default theme;
